<template>
	<div class="limitWidth">
		<div v-if="!initialSetupComplete">
			<v-container>
				<v-row>
					<v-col cols="12" md="6">
						<v-skeleton-loader
							class="mx-auto border"
							max-width="300"
							type="image, article"
						></v-skeleton-loader>
					</v-col>

					<v-col cols="12" md="6">
						<v-skeleton-loader
							class="mx-auto border"
							max-width="300"
							type="image, article"
						></v-skeleton-loader>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<div v-else>
			<v-container fluid>
				<v-row dense>
					<v-col cols="12" order="1" order-md="1">
						<div class="my-2">
							<div
								class="poppins-semibold nyGreenAlt--text text--darken-2 mb-2"
								style="font-size: 0.8rem"
							>
								Ciao {{ UserProfile.Name }}!
							</div>
							<div
								class="poppins-regular"
								:class="{
									WelcomeTextMessage:
										$vuetify.breakpoint.smAndDown,
									WelcomeTextMessageMdAndUp:
										$vuetify.breakpoint.mdAndUp
								}"
							>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step1IntroductionNotBooked
									"
									>Abbiamo trovato
									{{
										NutritionistProfile.Gender === 1
											? "il tuo "
											: "la tua "
									}}
									nutrizionista!</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step2IntroductionBooked
									"
									>Il tuo percorso sta per iniziare!</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step3IntroductionNotBooked
									"
									>Il cambiamento inizia oggi!</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step4VisitBooked
									"
								>
									<span v-if="!hasExpiringBooking"
										>Un piccolo promemoria: la visita
										aspetta il suo pagamento!</span
									>
									<span v-else>
										<v-icon size="18"
											>fas fa-alarm-exclamation</v-icon
										>
										Ultima chiamata: manca poco per pagare e
										confermare!</span
									>
								</template>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step5VisitPaid
									"
									>Manca poco alla tua visita
									nutrizionale</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step6VisitCompleted
									"
									>Il tuo percorso è appena
									iniziato!</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step7RecurringVisitBooked
									"
								>
									<span v-if="!hasExpiringBooking">
										Un piccolo promemoria: la visita aspetta
										il suo pagamento!
									</span>
									<span v-else>
										<v-icon size="18"
											>fas fa-alarm-exclamation</v-icon
										>
										È quasi ora! Ricorda che la scadenza per
										il pagamento si avvicina!</span
									>
								</template>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step8RecurringVisitPaid
									"
									>Manca poco alla tua visita
									nutrizionale</template
								>
								<template
									v-if="
										OnboardingStatus ===
											OnboardingStep.Step9RecurringVisitCompleted
									"
									>Non fermarti: il tuo viaggio è in piena
									crescita! 🌱
								</template>
							</div>
						</div>
					</v-col>

					<v-col cols="12" md="6" order="1" order-md="2">
						<template
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step1IntroductionNotBooked
							"
						>
							<BookIc v-if="1"
								:PatientProfile="PatientProfile"
								:NutritionistProfile="NutritionistProfile"
								@bookingCreated="
									OnBookingCreatedFromCalendar
								"
							>
							</BookIc>

						</template>

						<v-card
							color="nyroseLight"
							class="mb-3"
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step2IntroductionBooked
							"
						>
							<v-card-text>
								<div
									class="nyrose--text TitleFont text-center mb-3 CardTitleSize"
								>
									Hai l'incontro conoscitivo gratuito fissato
								</div>
								<div class="poppins-regular text-center">
									<div
										v-for="booking in bookings"
										:key="booking.BookingId"
									>
										<MiniBookingCard
											:booking="booking"
											@BookingCanceled="
												OnBookingCancelledByPatient
											"
										>
										</MiniBookingCard>
									</div>
								</div>
								<div
									class="poppins-regular"
									:class="{
										'px-5': $vuetify.breakpoint.mdAndUp
									}"
								>
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-info-circle</v-icon
									>
									Se avrai un imprevisto potrai sempre
									spostare o annullare la videochiamata.
									<br />
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-comment-alt-dots </v-icon
									>Ti basterà inviare un messaggio
									{{
										NutritionistProfile.Gender === 1
											? "al tuo "
											: "alla tua "
									}}
									nutrizionista in chat
								</div>
							</v-card-text>
						</v-card>

						<v-card
							color="nyroseLight"
							class="mb-3"
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step3IntroductionCompleted
							"
						>
							<v-card-text>
								<div
									class="nyrose--text TitleFont text-center mb-3 CardTitleSize"
								>
									Prenota la tua prima visita
								</div>
								<div class="poppins-regular text-center">
									Scrivi
									{{
										NutritionistProfile.Gender === 1
											? "al tuo "
											: "alla tua "
									}}
									nutrizionista in chat per prenotare la tua
									prossima visita nutrizionale e ricevere un
									supporto su misura per raggiungere i tuoi
									obiettivi.
									<br />

									<div class="text-center mt-3">
										<v-btn
											class="text-transform-none"
											dark
											large
											color="nyrose"
											to="/Chat"
										>
											<v-icon left
												>fas fa-fw
												fa-comment-alt-dots</v-icon
											>
											Scrivi
											{{
												NutritionistProfile.Gender === 1
													? "al tuo "
													: "alla tua "
											}}
											nutrizionista
										</v-btn>
									</div>
								</div>
							</v-card-text>
						</v-card>

						<v-card
							color="nyroseLight"
							class="mb-3"
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step4VisitBooked ||
									OnboardingStatus ===
										OnboardingStep.Step7RecurringVisitBooked
							"
						>
							<v-card-text>
								<div
									class="nyrose--text TitleFont text-center mb-3 CardTitleSize"
								>
									Il prossimo appuntamento
								</div>

								<div class="poppins-regular text-center">
									<div
										v-for="booking in bookings.filter(
											b =>
												b.BookingTypeId !==
													BookingTypesEnum.FREE &&
												b.BookingStatusId ===
													BookingStatusIdEnum.WAITINGFORPAYMENT
										)"
										:key="booking.BookingId"
									>
										<MiniBookingCard :booking="booking">
										</MiniBookingCard>
									</div>
								</div>

								<div class="poppins-regular">
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-info-circle</v-icon
									>
									Se avrai un imprevisto potrai spostare o
									annullare la videochiamata entro 2 giorni
									dall'appuntamento.
									<br />
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-comment-alt-dots
									</v-icon>
									Ti basterà inviare un messaggio
									{{
										NutritionistProfile.Gender === 1
											? "al tuo "
											: "alla tua "
									}}
									nutrizionista in chat.
								</div>
							</v-card-text>
						</v-card>

						<v-card
							color="nyroseLight"
							class="mb-3"
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step5VisitPaid ||
									OnboardingStatus ===
										OnboardingStep.Step8RecurringVisitPaid
							"
						>
							<v-card-text>
								<div
									class="nyrose--text TitleFont text-center mb-3 CardTitleSize"
								>
									Il prossimo appuntamento
								</div>
								<div></div>
								<div class="poppins-regular text-center">
									<div
										v-for="booking in bookings.filter(
											b =>
												b.BookingTypeId !==
													BookingTypesEnum.FREE &&
												b.BookingStatusId ===
													BookingStatusIdEnum.BOOKED
										)"
										:key="booking.BookingId"
									>
										<MiniBookingCard :booking="booking">
										</MiniBookingCard>
									</div>
								</div>
								<div class="poppins-regular">
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-info-circle</v-icon
									>
									Se avrai un imprevisto potrai spostare o
									annullare la videochiamata entro 2 giorni
									dall'appuntamento.
									<br />
									<v-icon small color="nyrose" class="mr-2"
										>fas fa-fw fa-comment-alt-dots
									</v-icon>
									Ti basterà inviare un messaggio
									{{
										NutritionistProfile.Gender === 1
											? "al tuo "
											: "alla tua "
									}}
									nutrizionista in chat
								</div>
							</v-card-text>
						</v-card>

						<v-card
							color="nyroseLight"
							class="mb-3"
							v-if="
								OnboardingStatus ===
									OnboardingStep.Step6VisitCompleted ||
									OnboardingStatus ===
										OnboardingStep.Step9RecurringVisitCompleted
							"
						>
							<v-card-text>
								<div
									class="nyrose--text TitleFont text-center mb-3"
									style="font-size: 1rem;"
								>
									Prenota il tuo prossimo appuntamento
								</div>
								<div></div>
								<div class="poppins-regular mb-2">
									Appuntamenti regolari possono essere di
									grande aiuto per raggiungere i tuoi
									obiettivi e mantenere il tuo equilibrio.
								</div>

								<div class="poppins-regular text-center">
									<v-btn
										color="nyrose"
										class="text-transform-none"
										dark
										block
										large
										to="/Chat"
									>
										<v-badge
											color="red"
											v-if="TotalNewMessages > 0"
											overlap
										>
											<template v-slot:badge>
												<span>{{
													TotalNewMessages
												}}</span>
											</template>
											<v-icon color="white" left
												>fas fa-fw
												fa-comment-alt-dots</v-icon
											>
										</v-badge>
										<v-icon color="white" left v-else
											>fas fa-fw
											fa-comment-alt-dots</v-icon
										>
										<span
											:class="{
												'ml-3': TotalNewMessages
											}"
										>
											{{
												TotalNewMessages > 0
													? NutritionistProfile.Gender === 1
														? "Rispondi al tuo nutrizionista"
														: "Rispondi alla tua nutrizionista"
													: NutritionistProfile.Gender === 1
													? "Scrivi al tuo nutrizionista"
													: "Scrivi alla tua nutrizionista"
											}}</span
										>
									</v-btn>
								</div>
							</v-card-text>
						</v-card>

						<template v-if="$vuetify.breakpoint.mdAndUp">
							<AssistanceBox
								:PatientProfile="PatientProfile"
								:OnboardingStep="OnboardingStatus"
							></AssistanceBox>
							<SetPasswordCard class="mx-auto"></SetPasswordCard>
						</template>
					</v-col>
					<v-col
						cols="12"
						md="6"
						order="2"
						order-md="1"
						v-if="initialSetupComplete"
					>
						<NutritionistProfileExpandableCard
							:matching-skills="matchingSkills"
							:nutritionist-profile="NutritionistProfile"
							:nutritionist-tags="nutritionistTags"
						>
							<template
								v-slot:mail-button
								v-if="
									OnboardingStatus ===
										OnboardingStep.Step1IntroductionNotBooked
								"
							>
								<v-btn
									color="nyGreenAlt darken-2"
									class="text-transform-none"
									dark
									block
									large
									to="/Chat"
								>
									<v-badge
										color="red"
										v-if="TotalNewMessages > 0"
										overlap
									>
										<template v-slot:badge>
											<span>{{ TotalNewMessages }}</span>
										</template>
										<v-icon color="white" left
											>fas fa-fw
											fa-comment-alt-dots</v-icon
										>
									</v-badge>
									<v-icon color="white" left v-else
										>fas fa-fw fa-comment-alt-dots</v-icon
									>
									<span :class="{ 'ml-3': TotalNewMessages }"
										>Prenota l'incontro gratuito</span
									>
								</v-btn>
							</template>
						</NutritionistProfileExpandableCard>
						<div
							class="mt-3"
							v-if="
								(OnboardingStatus ===
									OnboardingStep.Step1IntroductionNotBooked ||
									OnboardingStatus ===
										OnboardingStep.Step2IntroductionBooked) &&
									PatientProfile.HasChangedNutritionist ===
										false
							"
						>
							<v-btn
								block
								large
								text
								class="text-transform-none"
								color="primary"
								@click="showChangeNutritionistDialog = true"
								>Vuoi cambiare il tuo nutrizionista?</v-btn
							>

							<matching-nutritionists
								@NutritionistChanged="OnNutritionistChanged"
								v-model="showChangeNutritionistDialog"
							></matching-nutritionists>
						</div>
					</v-col>
					<template v-if="$vuetify.breakpoint.smAndDown">
						<v-col cols="12" md="6" order="3">
							<AssistanceBox
								:PatientProfile="PatientProfile"
								:OnboardingStep="OnboardingStatus"
							>
							</AssistanceBox>
						</v-col>
						<v-col cols="12" md="6" order="4">
							<SetPasswordCard class="mx-auto"></SetPasswordCard>
						</v-col>
					</template>
				</v-row>
			</v-container>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SetPasswordCard from "./SetPassword";
import CrudClient from "@/services/CrudClient/";
import NutritionistProfileExpandableCard from "@/views/Patients/components/NutritionistProfileExpandableCard.vue";
import AssistanceBox from "@/views/Patients/components/AssistanceBox.vue";
import MiniBookingCard from "@/views/Patients/components/MiniBookingCard.vue";
import { BookingTypesEnum } from "@/components/NutriYou/nutriYouBookingTypesEnum";
import { BookingStatusIdEnum } from "@/components/NutriYou/nutriYouBookingStatusEnum";
import moment from "moment/moment";

import { OnboardingStep } from "@/views/Patients/components/OnboardingStep";
import MatchingNutritionists from "./MatchingNutritionists.vue";
import BookIc from "@/views/Patients/components/BookIc.vue";

export default {
	components: {
		BookIc,
		MatchingNutritionists,
		MiniBookingCard,
		AssistanceBox,
		NutritionistProfileExpandableCard,
		SetPasswordCard
	},
	data() {
		return {
			LoadingData: false,
			bookings: [],

			PatientProfile: null,
			NutritionistProfile: null,
			initialSetupComplete: false,
			matchingSkills: [],
			nutritionistTags: [],
			hasExpiringBooking: false,

			PatientTallyPreferences: null,

			showChangeNutritionistDialog: false,
			bookingTypeId: BookingTypesEnum.FREE
		};
	},
	props: {
		OnboardingStatus: {
			type: Number,
			required: true
		}
	},
	computed: {
		// BookingStatusIdEnum() {
		// 	return BookingStatusIdEnum;
		// },

		...mapGetters(["UserProfile", "TotalNewMessages"])
	},
	created() {
		this.CurrentPatientProfileService = new CrudClient(
			"CurrentPatient/Profile"
		);
		this.BookingsService = new CrudClient("CurrentPatient/Bookings");
		this.CurrentPatientNutritionistService = new CrudClient(
			"CurrentPatient/Nutritionist"
		);
		this.PublicNutritionistsService = new CrudClient(
			"Nutritionists/Public"
		);
		this.UserTags = new CrudClient("SGP/UserTags");

		this.OnboardingStep = OnboardingStep;

		this.BookingTypesEnum = BookingTypesEnum;
		this.BookingStatusIdEnum = BookingStatusIdEnum;
	},
	watch: {
		OnboardingStatus: async function(newVal, oldVal) {
			await this.LoadBookings();
		}
	},
	async mounted() {
		await this.InitialSetup();
	},

	beforeDestroy() {},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		async InitialSetup() {
			this.PatientProfile = await this.CurrentPatientProfileService.Get();
			this.PatientTallyPreferences = await this.CurrentPatientProfileService.Get(
				"TallyPreferences"
			);

			this.$log.debug(
				"PatientTallyPreferences",
				this.PatientTallyPreferences
			);
			// PreferredStartType	2
			// PhoneCall = 1,
			// 	VideoCall = 2,
			// 	DirectStart = 3

			if (this.PatientProfile.DefaultNutritionistUserId) {
				await this.LoadBookings();

				this.NutritionistProfile = await this.PublicNutritionistsService.Get(
					this.PatientProfile.DefaultNutritionistUserId
				);

				try {
					this.matchingSkills = await this.CurrentPatientNutritionistService.Get(
						"MatchingSkills"
					);
				} catch (error) {
					this.matchingSkills = [];
					this.$captureError(error);
				}

				try {
					this.nutritionistTags = (
						await this.UserTags.Get(
							"User/" +
								this.PatientProfile.DefaultNutritionistUserId
						)
					).Data;
				} catch (error) {
					this.$captureError(error);
				}
			}
			this.initialSetupComplete = true;
		},

		getDateString() {
			const today = new Date();
			// Attention: Janyary is 0
			return `${today.getFullYear()}/${today.getMonth() +
				1}/${today.getDate()}`;
		},

		async LoadBookings() {
			try {
				const orderBy = "BookingTime:asc";

				const formattedToday = this.getDateString();

				let filter = `BookingTime:gt:${formattedToday}`;

				filter += ";BookingStatusId:in:1,2,4";

				const pageSize = 3;

				this.LoadingData = true;
				const res = await this.BookingsService.GetPaged({
					limit: pageSize,
					skip: 0,
					fields: "*, BookingType.Name",
					filter: filter,
					orderBy: orderBy
				});
				this.bookings = res.Data;
			} catch (error) {
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
				this.$captureError(error);
			} finally {
				this.LoadingData = false;
			}

			// check if there is a booking with waiting payment state and near to expire date
			const now = moment();

			this.hasExpiringBooking = this.bookings
				.filter(
					b =>
						b.BookingTypeId !== BookingTypesEnum.FREE &&
						b.BookingStatusId ===
							BookingStatusIdEnum.WAITINGFORPAYMENT
				)
				.some(b => moment(b.BookingTime).diff(now, "days") <= 3);
		},

		OnBookingCreatedFromCalendar() {
			this.$log.debug("OnBookingCreatedFromCalendar");
			this.$emit("OnBookingCreatedFromCalendar");
		},

		OnNutritionistChanged() {
			window.location.reload();
		},

		OnBookingCancelledByPatient() {
			this.$log.debug("OnBookingCancelledByPatient");
			this.$emit("OnBookingCreatedFromCalendar");
		}

		// correspondingFields.PreferredStartType
	}
};
</script>
<i18n>
	{
		"it":{
		}
	}
</i18n>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.BorderedBox {
	background-color: $ny_blueLight;
	border: 2px solid $ny_blue !important;
}

.WelcomeTextMessage {
	font-size: 1.2rem;
}

.WelcomeTextMessageMdAndUp {
	font-size: 1.6rem;
}
</style>
